// import React, { useEffect, useState, useRef } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import la from "./../../assets/images/left-arrow.svg";
// import ra from "./../../assets/images/right-arrow.svg";
// //import { WebApiURL } from '../Constants/Constants';
// import { WebApiURL } from '../../Constants/Constants';

// import LogoSlider from "./LogoSlider";

// function LatestMarineInfo() {
//   const nextRef = useRef(null);
//   const prevRef = useRef(null);
//   const [newsItems, setNewsItems] = useState([]);

//   useEffect(() => {
//       //fetch(`${WebApiURL}LatestUpdates/TopItems`)
//     // fetch("http://localhost:5287/api/LatestUpdates/TopItems")
//     //fetch("http://10.0.0.33:8081/api/LatestUpdates/TopItems")
//     fetch(`${WebApiURL}LatestUpdates/TopItems`)
//       .then((res) => res.json())
//       .then((data) => {
//         const formatted = data?.map((item) => ({
//           id: item.itemId,
//           title: item.itemName,
//           description: item.itemDescription,
//           link: formatURL(item.itemURL),
//           image: formatURL(item.itemImage),
//           type: item.itemType,
//           category: item.category,
//           createdDate: item.createdDate,
//         }));
//         setNewsItems(formatted);
//       })
//       .catch((err) => console.error("Error fetching news:", err));
//   }, []);

//   // Helper to handle file paths and URLs properly
//   const formatURL = (url) => {
//     if (!url) return "";
//     if (url.startsWith("\\\\")) {
//       // Convert UNC path to API-accessible endpoint if needed
//       return `${url.replace(/\\/g, "/")}`;
//     }
//     return url;
//   };

//   return (
//     <>
//       <style>{`
//         .latest-marine-info .latest-news-img {
//           width: 100%;
//           height: 189.1px;
//           object-fit: cover;
//           border-radius: 8px;
//         }

//         @media (max-width: 768px) {
//           .latest-marine-info .latest-news-img {
//             height: 160px;
//           }
//         }

//         .latest-marine-info .news-card {
//           display: block;
//           text-decoration: none;
//           color: inherit;
//         }

//         .latest-marine-info .news-card h3 {
//           font-size: 1rem;
//           font-weight: 600;
//           margin-top: 10px;
//           line-height: 1.3;
//           text-align: center;
//         }

//         .latest-marine-info .news-card p {
//           font-size: 0.9rem;
//           margin-top: 6px;
//           text-align: center;
//           color: #555;
//         }

//         .latest-marine-info .latest-news-slider {
//           position: relative;
//           padding: 0;
//         }
//       `}</style>

//       <section className="latest-marine-info px-3" id="latest-marine-info">
//         <div className="container max-1330">
//           <h1 className="section-title text-center">In Focus</h1>

//           <div className="latest-news-slider">
//             <Swiper
//               modules={[Navigation]}
//               navigation={{
//                 nextEl: ".custom-next",
//                 prevEl: ".custom-prev",
//               }}
//               spaceBetween={20}
//               slidesPerView={5}
//               breakpoints={{
//                 0: { slidesPerView: 1.1, spaceBetween: 15 },
//                 576: { slidesPerView: 2, spaceBetween: 15 },
//                 768: { slidesPerView: 3, spaceBetween: 20 },
//                 992: { slidesPerView: 4, spaceBetween: 20 },
//                 1200: { slidesPerView: 5, spaceBetween: 20 },
//               }}
//               onInit={(swiper) => {
//                 swiper.params.navigation.nextEl = nextRef.current;
//                 swiper.params.navigation.prevEl = prevRef.current;
//                 swiper.navigation.init();
//                 swiper.navigation.update();
//               }}
//               className="mySwiper card-list"
//             >
//               {newsItems.map((news) => (
//                 <SwiperSlide key={news.id}>
//                   <a
//                     href={news.link}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="news-card"
//                   >
//                     <div className="news-image-wrapper">
//                       <img
//                         src={news.image}
//                         alt={news.title}
//                         className="latest-news-img"
//                       />
//                     </div>
//                     <h3>{news.title}</h3>
//                     <p>{news.description}</p>
//                   </a>
//                 </SwiperSlide>
//               ))}
//             </Swiper>

//             <div className="latest-marine-navigation">
//               <button ref={prevRef} className="custom-prev">
//                 <img src={la} alt="Previous" />
//               </button>
//               <button ref={nextRef} className="custom-next">
//                 <img src={ra} alt="Next" />
//               </button>
//             </div>
//           </div>

//           <LogoSlider />
//         </div>
//       </section>
//     </>
//   );
// }

// export default LatestMarineInfo;



// import React, { useEffect, useState,useRef } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import la from './../../assets/images/left-arrow.svg';
// import ra from './../../assets/images/right-arrow.svg';

// import LogoSlider from "./LogoSlider";

// function LatestMarineInfo() {
//   const nextRef = useRef(null);
//   const prevRef = useRef(null);
//   const [newsItems, setNewsItems] = useState([]);

//   useEffect(() => {
//     fetch("http://10.0.0.33:8081/api/LatestUpdates/TopItems")
//     //fetch("https://blog.samsa.org.za/wp-json/wp/v2/posts?per_page=6&_embed")
//       .then((res) => res.json())
//       .then((data) => {
//         const formatted = data?.map((item) => ({
//           id: item.id,
//           title: item.title.rendered,
//           link: item.link,
//           image:
//             item._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
//             item.content.rendered.match(/<img.*?src=\"(.*?)\"/)?.[1] ||
//             "",
//         }));
//         setNewsItems(formatted);
//       })
//       .catch((err) => console.error("Error fetching news:", err));
//   }, []);

//   return (
//     <>
//       <style>{`
//         /* Match image style from Services */
//         .latest-marine-info .latest-news-img {
//           width: 100%;
//           height: 189.1px;
//           object-fit: cover;
//           border-radius: 8px;
//         }

//         @media (max-width: 768px) {
//           .latest-marine-info .latest-news-img {
//             height: 160px;
//           }
//         }

//         .latest-marine-info .news-card {
//           display: block;
//           text-decoration: none;
//           color: inherit;
//         }

//         .latest-marine-info .news-card h3 {
//           font-size: 1rem;
//           font-weight: 600;
//           margin-top: 10px;
//           line-height: 1.3;
//           text-align: center;
//         }

//         /* Align with Services by same padding */
//         .latest-marine-info .latest-news-slider {
//           position: relative;
//           padding: 0;
//         }
//       `}</style>

//       <section className="latest-marine-info px-3" id="latest-marine-info">
//         <div className="container max-1330">
//           <h1 className="section-title text-center">Latest News</h1>

//           {/* Slider without buttons */}
//           <div className="latest-news-slider">
//             <Swiper
//               modules={[Navigation]}
//               navigation={{
//                                 nextEl: ".custom-next",  // Custom next button
//                                 prevEl: ".custom-prev",  // Custom prev button
//                             }}
//               spaceBetween={20}
//               slidesPerView={5}
//               breakpoints={{
//                 0: { slidesPerView: 1.1, spaceBetween: 15 },
//                 576: { slidesPerView: 2, spaceBetween: 15 },
//                 768: { slidesPerView: 3, spaceBetween: 20 },
//                 992: { slidesPerView: 4, spaceBetween: 20 },
//                 1200: { slidesPerView: 5, spaceBetween: 20 },
//               }}
//              onInit={(swiper) => {
//                                 swiper.params.navigation.nextEl = nextRef.current;
//                                 swiper.params.navigation.prevEl = prevRef.current;
//                                 swiper.navigation.init();
//                                 swiper.navigation.update();
//                             }}
//             className="mySwiper card-list"
//             >
//               {newsItems.map((news) => (
//                 <SwiperSlide key={news.id}>
//                   <a
//                     href={news.link}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="news-card"
//                   >
//                     <div className="news-image-wrapper">
//                       <img
//                         src={news.image}
//                         alt={news.title}
//                         className="latest-news-img"
//                       />
//                     </div>
//                     <h3
//                       dangerouslySetInnerHTML={{ __html: news.title }}
//                     />
//                   </a>
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//             <div className="latest-marine-navigation">
//                             {/* Custom Navigation Buttons */}
//                             <button ref={prevRef} className="custom-prev">
//                                     <img src={la} alt="" className="" />
//                             </button>
//                             <button ref={nextRef} className="custom-next">
//                                     <img src={ra} alt="" className="" />
//                             </button>
//              </div>
//           </div>

//           <LogoSlider />
//         </div>
//       </section>
//     </>
//   );
// }

// export default LatestMarineInfo;


// API DATA Latest Items





// import React, { useEffect, useState,useRef } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import la from './../../assets/images/left-arrow.svg';
// import ra from './../../assets/images/right-arrow.svg';

// import LogoSlider from "./LogoSlider";

// function LatestMarineInfo() {
//   const nextRef = useRef(null);
//   const prevRef = useRef(null);
//   const [newsItems, setNewsItems] = useState([]);

//   useEffect(() => {
//     fetch("http://10.0.0.33:8081/api/LatestUpdates/TopItems")
//       .then((res) => res.json())
//       .then((data) => {
//         const formatted = data.map((item) => ({
//           id: item.id,
//           title: item.title.rendered,
//           link: item.link,
//           image:
//             item._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
//             item.content.rendered.match(/<img.*?src=\"(.*?)\"/)?.[1] ||
//             "",
//         }));
//         setNewsItems(formatted);
//       })
//       .catch((err) => console.error("Error fetching news:", err));
//   }, []);

//   return (
//     <>
//       <style>{`
//         /* Match image style from Services */
//         .latest-marine-info .latest-news-img {
//           width: 100%;
//           height: 189.1px;
//           object-fit: cover;
//           border-radius: 8px;
//         }

//         @media (max-width: 768px) {
//           .latest-marine-info .latest-news-img {
//             height: 160px;
//           }
//         }

//         .latest-marine-info .news-card {
//           display: block;
//           text-decoration: none;
//           color: inherit;
//         }

//         .latest-marine-info .news-card h3 {
//           font-size: 1rem;
//           font-weight: 600;
//           margin-top: 10px;
//           line-height: 1.3;
//           text-align: center;
//         }

//         /* Align with Services by same padding */
//         .latest-marine-info .latest-news-slider {
//           position: relative;
//           padding: 0;
//         }
//       `}</style>

//       <section className="latest-marine-info px-3" id="latest-marine-info">
//         <div className="container max-1330">
//           <h1 className="section-title text-center">Latest News</h1>

//           {/* Slider without buttons */}
//           <div className="latest-news-slider">
//             <Swiper
//               modules={[Navigation]}
//               navigation={{
//                                 nextEl: ".custom-next",  // Custom next button
//                                 prevEl: ".custom-prev",  // Custom prev button
//                             }}
//               spaceBetween={20}
//               slidesPerView={5}
//               breakpoints={{
//                 0: { slidesPerView: 1.1, spaceBetween: 15 },
//                 576: { slidesPerView: 2, spaceBetween: 15 },
//                 768: { slidesPerView: 3, spaceBetween: 20 },
//                 992: { slidesPerView: 4, spaceBetween: 20 },
//                 1200: { slidesPerView: 5, spaceBetween: 20 },
//               }}
//              onInit={(swiper) => {
//                                 swiper.params.navigation.nextEl = nextRef.current;
//                                 swiper.params.navigation.prevEl = prevRef.current;
//                                 swiper.navigation.init();
//                                 swiper.navigation.update();
//                             }}
//             className="mySwiper card-list"
//             >
//               {newsItems.map((news) => (
//                 <SwiperSlide key={news.id}>
//                   <a
//                     href={news.link}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="news-card"
//                   >
//                     <div className="news-image-wrapper">
//                       <img
//                         src={news.image}
//                         alt={news.title}
//                         className="latest-news-img"
//                       />
//                     </div>
//                     <h3
//                       dangerouslySetInnerHTML={{ __html: news.title }}
//                     />
//                   </a>
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//             <div className="latest-marine-navigation">
//                             {/* Custom Navigation Buttons */}
//                             <button ref={prevRef} className="custom-prev">
//                                     <img src={la} alt="" className="" />
//                             </button>
//                             <button ref={nextRef} className="custom-next">
//                                     <img src={ra} alt="" className="" />
//                             </button>
//              </div>
//           </div>

//           <LogoSlider />
//         </div>
//       </section>
//     </>
//   );
// }

// export default LatestMarineInfo;



import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import la from "./../../assets/images/left-arrow.svg";
import ra from "./../../assets/images/right-arrow.svg";
//import { WebApiURL } from '../Constants/Constants';
import { WebApiURL } from '../../Constants/Constants';

import LogoSlider from "./LogoSlider";

function LatestMarineInfo() {
  const nextRef = useRef(null);
  const prevRef = useRef(null);
  const [newsItems, setNewsItems] = useState([]);

  useEffect(() => {
      //fetch(`${WebApiURL}LatestUpdates/TopItems`)
    // fetch("http://localhost:5287/api/LatestUpdates/TopItems")
    //fetch("http://10.0.0.33:8081/api/LatestUpdates/TopItems")
    fetch(`${WebApiURL}LatestUpdates/TopItems`)
      .then((res) => res.json())
      .then((data) => {
        const formatted = data?.map((item) => ({
          id: item.itemId,
          title: item.itemName,
          description: item.itemDescription,
          link: formatURL(item.itemURL),
          image: formatURL(item.itemImage),
          type: item.itemType,
          category: item.category,
          createdDate: item.createdDate,
        }));
        setNewsItems(formatted);
      })
      .catch((err) => console.error("Error fetching news:", err));
  }, []);

  // Helper to handle file paths and URLs properly
  const formatURL = (url) => {
    if (!url) return "";
    if (url.startsWith("\\\\")) {
      // Convert UNC path to API-accessible endpoint if needed
      return `${url.replace(/\\/g, "/")}`;
    }
    return url;
  };

  return (
    <>
      <style>{`
        .latest-marine-info .latest-news-img {
          width: 100%;
          height: 189.1px;
          object-fit: cover;
          border-radius: 8px;
        }

        @media (max-width: 768px) {
          .latest-marine-info .latest-news-img {
            height: 160px;
          }
          .latest-marine-info .news-card {
          margin-left: 20px;
          }
        }

        .latest-marine-info .news-card {
          display: block;
          text-decoration: none;
          color: inherit;
        }

        .latest-marine-info .news-card h3 {
          font-size: 1rem;
          font-weight: 600;
          margin-top: 10px;
          line-height: 1.3;
          text-align: center;
        }

        .latest-marine-info .news-card p {
          font-size: 0.9rem;
          margin-top: 6px;
          text-align: center;
          color: #555;
        }

        .latest-marine-info .latest-news-slider {
          position: relative;
          padding: 0;
        }
      `}</style>

      <section className="latest-marine-info px-3" id="latest-marine-info">
        <div className="container max-1330">
          <h1 className="section-title text-center">In Focus</h1>

          <div className="latest-news-slider">
            <Swiper
              modules={[Navigation]}
              navigation={{
                nextEl: ".custom-next",
                prevEl: ".custom-prev",
              }}
              spaceBetween={20}
              slidesPerView={4}
              breakpoints={{
                0: { slidesPerView: 1.1, spaceBetween: 15 },
                576: { slidesPerView: 2, spaceBetween: 15 },
                768: { slidesPerView: 3, spaceBetween: 20 },
                992: { slidesPerView: 4, spaceBetween: 20 },
                // 1200: { slidesPerView: 5, spaceBetween: 20 },
              }}
              onInit={(swiper) => {
                swiper.params.navigation.nextEl = nextRef.current;
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.navigation.init();
                swiper.navigation.update();
              }}
              className="mySwiper card-list"
            >
              {newsItems.map((news) => (
                <SwiperSlide key={news.id}>
                  <a
                    href={news.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="news-card"
                  >
                    <div className="news-image-wrapper">
                      <img
                        src={news.image}
                        alt={news.title}
                        className="latest-news-img"
                      />
                    </div>
                    <h3>{news.title}</h3>
                    <p>{news.description}</p>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* <div className="latest-marine-navigation">
              <button ref={prevRef} className="custom-prev">
                <img src={la} alt="Previous" />
              </button>
              <button ref={nextRef} className="custom-next">
                <img src={ra} alt="Next" />
              </button>
            </div> */}
          </div>

          <LogoSlider />
        </div>
      </section>
    </>
  );
}

export default LatestMarineInfo;